import { render, staticRenderFns } from "./IconMore.vue?vue&type=template&id=ef25b52a&scoped=true&"
var script = {}
import style0 from "./IconMore.vue?vue&type=style&index=0&id=ef25b52a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef25b52a",
  null
  
)

export default component.exports